module.exports = "<nz-modal [nzWrapClassName]=\"'vertical-center-modal'\" [nzVisible]=\"display\" [nzFooter]=\"false\"\n  [nzContent]=\"modalContent\" (nzOnCancel)=\"handleCancel()\" (nzOnOk)=\"handleOk()\">\n</nz-modal>\n<ng-template #modalContent>\n  <top-detail></top-detail>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/topupdetail/topupdetail.component.html
// module id = 1150
// module chunks = 73